import axios from "axios";
import { BFF_BASE_PATH } from "@/core/utils";

export function GET(path: string): Promise<any> {
  return axios.get(`${BFF_BASE_PATH}/${path}`);
}

export function POST(path: string, data?: any): Promise<any> {
  return axios.post(`${BFF_BASE_PATH}/${path}`, data);
}

export function PUT(path: string, data?: any): Promise<any> {
  return axios.put(`${BFF_BASE_PATH}/${path}`, data);
}

export function DELETE(path: string): Promise<any> {
  return axios.delete(`${BFF_BASE_PATH}/${path}`);
}
